import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <main className="pt-40 max-w-xl mx-auto px-6 text-center" data-testid="payment-cancel-page">
        <h1 className="text-4xl font-light tracking-tight">Payment cancelled.</h1>
        <p className="mt-4 text-slate-600">No charges were made. You can resume your booking any time.</p>
        <Link to="/tours" data-testid="back-to-tours" className="mt-8 inline-flex btn-pill bg-slate-900 text-white hover:bg-slate-800">Back to tours</Link>
      </main>
    </div>
  );
}
